import { Component, OnInit } from '@angular/core';
import { ExtraService } from '../../core/services/extra.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase/app';
import { Constants } from '../../core/config/Constants';
import { VenueMap } from '../../core/models/venue-detail'; 
import { VenueDetailService } from '../../core/services/venue-detail.service';
import { ContentsMandatory } from '../../core/models/contents-mandatory';

@Component({
  selector: 'app-venue-detail',
  templateUrl: './venue-detail.component.html',
  styleUrls: ['./venue-detail.component.css'],
  providers:[VenueDetailService]
})
export class VenueDetailComponent implements OnInit {
  imageUrl: string;
  buttonMessage = Constants.SUBMIT_BUTTON_MESSAGE;
  eventId:string='';
  message:string=null;
  isError:boolean=false;
  errorMessage: Array<string> = new Array();
  disableButton:boolean=true;

  imageFile = File;
  uploadFileName:string = null;
  uploadprogress:number = null;

  venueMap = new VenueMap();

  constructor(private venueDetailService: VenueDetailService, private router:Router,private extraService:ExtraService,private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      let id = params['eventId'];
      if(id) {
        //console.log(id);
        this.eventId = id;
        this.extraService.setCurrentEventId(id);
        this.setVenueData(id);
      } 
    });
  }

  setVenueData(id:string) {
    this.venueMap = new VenueMap();
    this.venueDetailService.getVenue(id).subscribe(event=>{
      if(event) {
        this.venueMap = event;
        if(event.has_venue_map) {
          this.venueMap.has_venue_map = event.has_venue_map;
        } if(event.venue_map_id){
          this.venueMap.venue_map_id = event.venue_map_id;
          this.venueDetailService.getImageUrl(this.eventId, event.venue_map_id).subscribe(item=>{
            if(item) {
              this.imageUrl = item.fileUrl;
            }
          });
        }
      }
    });
  }

  onBasicUpload(event) {
    if(event.files[0]) {
      let uploadTask = this.venueDetailService.uploadFile(this.eventId,event.files[0]);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
        (snapshot) =>  {
          this.disableButton = false;
          this.message = 'File Uploading...';
          this.uploadFileName = event.files[0].filename;
          this.uploadprogress = Math.floor((uploadTask.snapshot.bytesTransferred /uploadTask.snapshot.totalBytes) * 100);
          
        },
        (error) => {

        },
        () => {
          let contentsMandatory = new ContentsMandatory();
          contentsMandatory.category = Constants.CONTENT_M_TYPE_VENUE;
          contentsMandatory.eventId = this.eventId;
          contentsMandatory.filename = event.files[0].name;
          contentsMandatory.extension = event.files[0].name.split('.').pop();
          contentsMandatory.sizeInBytes = event.files[0].size;
          contentsMandatory.fileUrl = uploadTask.snapshot.downloadURL;
         let key = this.venueDetailService.addContentMandatory(contentsMandatory);
          if(key) {
            this.message = 'File Uploaded Successfully';
            this.venueMap.venue_map_id = key;          
            setTimeout(function() {
              this.message = null;
              this.disableButton = true;
            }.bind(this), 2000);
          }
        }
      );
    }
  }


  addVenue() {
    if(this.validate()) {
      console.log(this.venueMap)
      this.venueDetailService.updateVenue(this.eventId, this.venueMap).then(response=>{
        this.message = 'VenueMap Updated Successfully';
        setTimeout(function() {
          this.message = null;
          this.disableButton = true;
        }.bind(this), 1000);
      }).catch(error=>{
        this.isError = true;
        this.errorMessage.push(error.message);
        console.log(error.message);
      })
    }
  }

  validate() {
    this.isError = false;
    this.errorMessage = new Array();
    this.message = null;
    let valid = true;
    return valid;
  }

}



// WEBPACK FOOTER //
// /workspace/backend-server/src/app/event/venue-detail/venue-detail.component.ts